import styled, { DefaultTheme } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { AdStatus } from '@/types';

function getBg(status: AdStatus, theme: DefaultTheme) {
  switch (status) {
    case AdStatus.Pending:
    case AdStatus.Published: {
      return theme.palette.system.yellow;
    }
    case AdStatus.AwaitingPayment:
    case AdStatus.Expired:
    case AdStatus.Archived: {
      return theme.palette.tertiary.labels;
    }
    case AdStatus.Rejected: {
      return theme.palette.system.red;
    }
    default: {
      return 'transparent';
    }
  }
}

export const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 10px;
  }
`;

export const Box = styled.div<{ $status: AdStatus }>`
  display: flex;
  gap: 5px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

export const ButtonBox = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 15px;
  }
`;

export const BoxStrip = styled.div<{ $status: AdStatus }>`
  width: 5px;
  flex-shrink: 0;
  border-radius: 15px;
  background-color: ${({ theme, $status }) => getBg($status, theme)};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const BoxCard = styled.div<{ $status: AdStatus }>`
  flex: 1;
  display: grid;
  gap: 15px;
  padding: 15px 10px;
  border-radius: 14px;
  color: ${({ theme }) => theme.palette.system.white};
  background-color: ${({ theme, $status }) => getBg($status, theme)};

  span {
    white-space: break-spaces;
  }

  ul {
    display: grid;
    gap: 10px;
    padding-left: 15px;
    margin-top: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 15px;
    border-radius: 0;
  }
`;

export const SingleRejectReason = styled(Typography.Caption)`
  margin-top: 16px;
  font-size: 15px;
  color: inherit;
`;

export const StatusText = styled(Typography.Text)`
  font-size: 15px;
  line-height: 24px;
`;
